module.exports = __webpack_public_path__ + "static/media/mask-group.3b2cc7e1.jpg";